import * as React from 'react';
import { Component } from 'react';
import { parse } from 'query-string';
import BPromise from 'bluebird';
import {
  ColumnDefinition,
  getFilters2,
  getOrder,
  getSearchFilter,
  getSearchOrder,
  getServerFieldSectionWhere,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, LIMIT } from 'Src/consts/table';
import {
  deleteForm,
  getAllForms,
  getForms,
  getFormCount,
  updateForm,
  createForm
} from 'Src/helpers/service/admin/forms';
import { Loader } from 'Src/components/Loader/Loader';
import { AppUser } from 'Src/views/App/App';
import './Forms.css';
import { SchoolForm } from 'Src/models/form';
import { SchoolFormForm } from 'Src/components/SchoolFormForm/SchoolFormForm';
import { GenericSummary } from 'Src/components/GenericSummary/GenericSummary';
import { Button } from 'Src/components/Button/Button';
import { FormSummary } from 'Src/components/FormSummary/FormSummary';
import { FORM_TABS } from 'Src/consts/form';
import { History, Location } from 'history';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import propz from 'propz';
import { AGE_GROUPS, AGE_GROUPS_SORTED } from 'Src/consts/school';
import { getPagesCount } from 'Src/helpers/table/table';
import { getSchoolStudentsCount } from 'Src/helpers/service/admin/students';
import {
  PeopleFilterChipOption,
  PeopleFilterChipSelect
} from 'Src/views/GenericView/AdminView/Users/PeopleFilterChipSelect';
import { PeopleFilterChips } from 'Src/views/GenericView/AdminView/Users/PeopleFilterChips';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Name',
    field: 'name',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['name']
  },
  {
    text: 'Year group',
    field: 'ageGroup',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: ['ageGroup']
  },
  {
    text: 'Student assignments',
    field: 'withoutStudents',
    isSort: false,
    type: FILTER_TYPE.CHECKBOX,
    accessor: ['withoutStudents']
  }
];

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

interface State {
  items: SchoolForm[];
  currentPage: number;
  selectedItems: SchoolForm[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  totalWithFilters: number;
  total: number;
  basePath: string;
  forms: SchoolForm[];
  deleteFormConfirmationModalText: string;
  deleteFormProhibitionModalText: string;
  formsWithoutStudents: SchoolForm[];
  editingForm: SchoolForm | null;

  isCreateOrEditFormModalOpen: boolean;
  isDeleteFormConfirmationModalOpen: boolean;
  isDeleteFormProhibitionModalOpen: boolean;
  isSelectionMenuOpen: boolean;
  saveError: string;
}

export class Forms extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      totalWithFilters: 0,
      total: 0,
      basePath: '',
      forms: [],
      deleteFormConfirmationModalText: '',
      deleteFormProhibitionModalText: '',
      formsWithoutStudents: [],
      editingForm: null,

      isCreateOrEditFormModalOpen: false,
      isDeleteFormConfirmationModalOpen: false,
      isDeleteFormProhibitionModalOpen: false,
      isSelectionMenuOpen: false,
      saveError: ''
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
      saveError: ''
    });

    this.setAdditionalItems().then(res => {
      this.setItems();
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems();
    }
  }

  setAdditionalItems() {
    const { user } = this.props;
    const promises = [getAllForms(user)];
    return BPromise.all(promises).then(([forms]) => {
      this.setState({
        forms: forms
      });

      return true;
    });
  }

  getFormsWhere(filters): any {
    const { user } = this.props;
    const filtersForServer = { ...filters };
    const withoutStudents = propz.get(filtersForServer, ['withoutStudents'], []);
    delete filtersForServer.withoutStudents;

    const where = getServerFieldSectionWhere(filtersForServer, { forms: this.state.forms });
    const selectedAgeGroups = propz.get(filters, ['ageGroup'], []);

    if (Array.isArray(selectedAgeGroups) && selectedAgeGroups.length > 0) {
      const ageGroupsNaming = propz.get(user, ['activeSchool', 'ageGroupsNaming']);
      const ageGroups = propz.get(AGE_GROUPS, [ageGroupsNaming], []);
      const ages = selectedAgeGroups.map(ageGroup => ageGroups.indexOf(ageGroup)).filter(age => age !== -1);

      delete where.ageGroup;
      if (ages.length > 0) {
        where.age = { $in: ages };
      }
    }

    if (Array.isArray(withoutStudents) && withoutStudents.indexOf('true') !== -1) {
      where.withoutStudents = true;
    }

    return where;
  }

  setItems() {
    const { history, user } = this.props;

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(COLUMNS, search);

    const isDataFiltered = isFilterExist2(filters);

    const where = this.getFormsWhere(filters);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const getFormsPromise = getForms(user, serverQueryFilter);
    const getFormCountPromise = getFormCount(user, where);
    const getFormsTotalCountPromise = getFormCount(user);

    return BPromise.all([getFormCountPromise, getFormsTotalCountPromise, getFormsPromise]).then(
      ([totalWithFiltersObj, totalObj, forms]) => {
        this.setState({
          currentPage: page,
          sortDirection: sortDirection,
          sortColumnsName: sortColumnsName,
          isShowFilter: false,
          isDataFiltered: isDataFiltered,
          filters: filters,
          items: forms,
          totalWithFilters: totalWithFiltersObj.count,
          total: totalObj.count,
          basePath: history.location.pathname,
          isLoading: false
        });

        return true;
      }
    );
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onItemClick = (index: number): void => {
    const { items } = this.state;
    const selectedForm = items[index];

    this.setState({
      editingForm: selectedForm,
      isCreateOrEditFormModalOpen: false
    });
  };

  onItemSelect = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedForm = items[index];

    const selectedFormIndex = selectedItems.findIndex(form => selectedForm.id === form.id);
    let selectedFormUpdated = [...selectedItems];

    if (selectedFormIndex !== -1) {
      selectedFormUpdated.splice(selectedFormIndex, 1);
    } else {
      selectedFormUpdated.push(selectedForm);
    }

    this.setState({
      selectedItems: selectedFormUpdated,
      isSelectAllChecked: false
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const formsFiltered = items.filter(form => {
      return selectedItems.every(selectedForm => selectedForm.id !== form.id);
    });

    const selectedForms = [...selectedItems, ...formsFiltered];

    this.setState({
      selectedItems: selectedForms,
      isSelectAllChecked: true,
      isSelectionMenuOpen: false
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters } = this.state;

    this.setState({
      isLoading: true,
      saveError: ''
    });

    const user = this.props.user;

    const where = this.getFormsWhere(filters);

    getAllForms(user, where).then(forms => {
      const formsFiltered = forms.filter(form => {
        return selectedItems.every(selectedForm => selectedForm.id !== form.id);
      });

      const selectedForms = [...selectedItems, ...formsFiltered];

      this.setState({
        selectedItems: selectedForms,
        isSelectAllChecked: true,
        isSelectionMenuOpen: false,
        isLoading: false
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isSelectionMenuOpen: false
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (filterField === 'ageGroup') {
      nextFilters.ageGroup = [];
    }

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      isShowFilter: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false,
      filters: {},
      isShowFilter: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: ''
    });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    if (isShowFilter) {
      const search = parse(this.props.history.location.search);
      this.setState({
        isShowFilter: false,
        filters: getFilters2(COLUMNS, search)
      });
      return;
    }

    this.setState({
      isShowFilter: true
    });
  };

  onSaveButtonClick = (data): void => {
    const { user, history } = this.props;
    const { selectedItems, total, editingForm } = this.state;

    this.setState({
      isLoading: true,
      saveError: ''
    });

    const { name, ageGroup } = data;
    const activeSchool = user.activeSchool;
    const ageGroupsNaming = activeSchool.ageGroupsNaming;

    const ageGroups = propz.get(AGE_GROUPS, [ageGroupsNaming]);

    const age = ageGroups.findIndex(group => group === ageGroup);
    const formToTransfer = {
      age: age,
      name: name.trim()
    };

    if (editingForm) {
      updateForm(user, editingForm.id, formToTransfer)
        .then((form: SchoolForm) => {
          this.setState({
            editingForm: null
          });

          this.setItems();
        })
        .catch(this.onSaveError);
      return;
    }

    switch (selectedItems.length) {
      case 0: {
        createForm(this.props.user, formToTransfer)
          .then((form: SchoolForm) => {
            const lastPage = getPagesCount(total + 1, LIMIT);

            history.push({
              pathname: this.state.basePath,
              search: `page=${lastPage}`
            });

            this.setState({
              isCreateOrEditFormModalOpen: false,
              selectedItems: [form]
            });

            this.setItems();
          })
          .catch(this.onSaveError);
        break;
      }
      case 1:
        const formId = selectedItems[0].id;
        updateForm(user, formId, formToTransfer)
          .then((form: SchoolForm) => {
            this.setState({
              isCreateOrEditFormModalOpen: false,
              selectedItems: [form]
            });

            this.setItems();
          })
          .catch(this.onSaveError);
        break;
    }
  };

  onSaveError = (): void => {
    this.setState({
      isLoading: false,
      saveError: 'The registration form could not be saved. Please check the details and try again.'
    });
  };

  onCancelButtonClick = (): void => {
    this.setState({
      isCreateOrEditFormModalOpen: false,
      editingForm: null,
      saveError: ''
    });
  };

  onTabClick = (event, index: number) => {
    event.preventDefault();

    //TODO_001 fix it
    this.setState({
      total: index
    });
  };

  onEditFormClick = event => {
    event.preventDefault();

    this.setState({
      isCreateOrEditFormModalOpen: true,
      saveError: ''
    });
  };

  getSummaryTabs(): React.ReactNode {
    const { selectedItems, items, forms } = this.state;

    switch (true) {
      case selectedItems.length === 1:
        return <FormSummary form={selectedItems[0]} />;
    }
  }

  renderForm() {
    const { isCreateOrEditFormModalOpen, selectedItems, saveError } = this.state;
    const { user } = this.props;

    switch (selectedItems.length) {
      case 0:
        return (
          <SimpleModal
            isOpen={isCreateOrEditFormModalOpen}
            title={'Create registration form'}
            customClass="schoolStructure-modal schoolStructure-modal--form"
            dialogStyle={{ maxWidth: 640 }}
            onCloseClick={this.onCancelButtonClick}
            showFooter={false}
          >
            {saveError && <div className="alert alert-danger mb-3">{saveError}</div>}
            <SchoolFormForm
              isOpen={isCreateOrEditFormModalOpen}
              onCloseClick={this.onCancelButtonClick}
              onFormCreated={this.onSaveButtonClick}
              user={user}
            />
          </SimpleModal>
        );
      case 1:
        return (
          <SimpleModal
            isOpen={isCreateOrEditFormModalOpen}
            title={'Edit registration form'}
            customClass="schoolStructure-modal schoolStructure-modal--form"
            dialogStyle={{ maxWidth: 640 }}
            onCloseClick={this.onCancelButtonClick}
            showFooter={false}
          >
            {saveError && <div className="alert alert-danger mb-3">{saveError}</div>}
            <SchoolFormForm
              isOpen={isCreateOrEditFormModalOpen}
              onCloseClick={this.onCancelButtonClick}
              onFormCreated={this.onSaveButtonClick}
              form={selectedItems[0]}
              user={user}
            />
          </SimpleModal>
        );
    }
  }

  onCreateFormClick = () => {
    this.setState({
      isCreateOrEditFormModalOpen: true,
      editingForm: null,
      selectedItems: [],
      saveError: ''
    });
  };

  onDeleteEditingFormClick = (): void => {
    const { editingForm } = this.state;
    if (!editingForm) {
      return;
    }
    this.setState({ selectedItems: [editingForm] }, this.onRemoveFormClick);
  };
  onRemoveFormClick = () => {
    const { user } = this.props;
    const { selectedItems } = this.state;

    const selectedItemsCount = selectedItems.length;

    const promises = selectedItems.map(item => {
      const { id: formId } = item;

      const where = {
        formId
      };

      return getSchoolStudentsCount(user, where);
    });

    this.setState({ isLoading: true });

    BPromise.all(promises).then(studentsCountsArray => {
      const formsWithStudens = [];
      const formsWithoutStudents = [];

      studentsCountsArray.forEach((item, index) => {
        const { count } = item;
        const form = selectedItems[index];
        const formName = selectedItems[index].name;
        count > 0 ? formsWithStudens.push(formName) : formsWithoutStudents.push(form);
      });

      const formsWithStudensCount: number = formsWithStudens.length;
      const formsWithoutStudentsCount: number = formsWithoutStudents.length;

      const formsWithStudensText: string = formsWithStudens.join(', ');
      const formsWithoutStudentsText: string = formsWithoutStudents.map(form => form.name).join(', ');

      const isAllSelectedFormsContainStudents: boolean = formsWithStudensCount > 0 && formsWithoutStudentsCount === 0;
      const isAllSelectedFormsNotContainStudents: boolean =
        formsWithStudensCount === 0 && formsWithoutStudentsCount > 0;
      const isSomeSelectedFormsContainStudentsSomeNot: boolean =
        formsWithStudensCount > 0 && formsWithoutStudentsCount > 0;

      let deleteFormConfirmationModalText: string;
      let deleteFormProhibitionModalText: string;

      switch (true) {
        case isAllSelectedFormsContainStudents:
          deleteFormProhibitionModalText = `The registration form(s) ${formsWithStudensText} cannot be deleted because students are linked to them. Move those students to another registration form first.`;

          this.setState({
            deleteFormProhibitionModalText,
            formsWithoutStudents,
            isDeleteFormProhibitionModalOpen: true,
            isLoading: false
          });

          break;

        case isAllSelectedFormsNotContainStudents:
          deleteFormConfirmationModalText = `Are you sure you want to remove ${
            selectedItemsCount === 1
              ? `registration form ${formsWithoutStudentsText}`
              : `${selectedItemsCount} registration forms`
          }?`;

          this.setState({
            deleteFormConfirmationModalText,
            formsWithoutStudents,
            isDeleteFormConfirmationModalOpen: true,
            isLoading: false
          });

          break;

        case isSomeSelectedFormsContainStudentsSomeNot:
          deleteFormConfirmationModalText = `Are you sure you want to remove ${formsWithoutStudentsCount} registration form(s)?\nThe registration form(s) ${formsWithStudensText} cannot be deleted because students are linked to them.`;

          this.setState({
            deleteFormConfirmationModalText,
            formsWithoutStudents,
            isDeleteFormConfirmationModalOpen: true,
            isLoading: false
          });

          break;
      }
    });
  };

  removeForm = () => {
    const { user } = this.props;
    const { formsWithoutStudents } = this.state;

    this.setState({ isLoading: true });

    const promises = formsWithoutStudents.map(form => {
      const { id } = form;

      return deleteForm(user, id);
    });

    BPromise.all(promises).then(() => {
      this.setState({
        selectedItems: [],
        isDeleteFormConfirmationModalOpen: false
      });

      this.setItems();
    });
  };

  openDeleteFormConfirmationModal = (): void => {
    this.setState({
      isDeleteFormConfirmationModalOpen: true
    });
  };

  closeDeleteFormConfirmationModal = (): void => {
    this.setState({
      isDeleteFormConfirmationModalOpen: false
    });
  };

  renderDeleteFormConfirmationModal() {
    const { isDeleteFormConfirmationModalOpen, deleteFormConfirmationModalText } = this.state;

    return (
      <SimpleModal
        isOpen={isDeleteFormConfirmationModalOpen}
        title={'Delete registration form'}
        body={
          <div className="schoolStructure-warningModal schoolStructure-warningModal--danger">
            <div className="schoolStructure-warningModal__icon">!</div>
            <p>{deleteFormConfirmationModalText}</p>
          </div>
        }
        buttonText={'Delete'}
        buttonCancelText="Cancel"
        onButtonClick={this.removeForm}
        onCloseClick={this.closeDeleteFormConfirmationModal}
        customClass="schoolStructure-modal schoolStructure-modal--warning schoolStructure-modal--danger"
        dialogStyle={{ maxWidth: 480 }}
      />
    );
  }

  openDeleteFormProhibitionModal = (): void => {
    this.setState({
      isDeleteFormProhibitionModalOpen: true
    });
  };

  closeDeleteFormProhibitionModal = (): void => {
    this.setState({
      isDeleteFormProhibitionModalOpen: false
    });
  };

  renderDeleteFormProhibitionModal() {
    const { isDeleteFormProhibitionModalOpen, deleteFormProhibitionModalText } = this.state;

    return (
      <SimpleModal
        isOpen={isDeleteFormProhibitionModalOpen}
        title={'Registration form is in use'}
        body={
          <div className="schoolStructure-warningModal">
            <div className="schoolStructure-warningModal__icon">!</div>
            <p>{deleteFormProhibitionModalText}</p>
          </div>
        }
        onCloseClick={this.closeDeleteFormProhibitionModal}
        buttonCancelText="Close"
        customClass="schoolStructure-modal schoolStructure-modal--warning"
        dialogStyle={{ maxWidth: 480 }}
      />
    );
  }

  renderSummary() {
    const { selectedItems } = this.state;
    const isOneItemSelected = selectedItems.length === 1;

    if (!isOneItemSelected) {
      return <div className="font-weight-bold">Select a form above</div>;
    }

    const summaryTabs = this.getSummaryTabs();

    const isShowEditButton = selectedItems.length === 1;

    return (
      <GenericSummary onTabClick={this.onTabClick} tabs={FORM_TABS} currentTabIndex={0}>
        {isShowEditButton && <Button onClick={this.onEditFormClick} text={'Edit'} customClass={'mt-3 mb-3'} />}
        {summaryTabs}
      </GenericSummary>
    );
  }

  stylizeCell = cell => {
    const isItemWithStudents = cell.rowData.isContainStudents;
    return isItemWithStudents ? '' : 'text-danger';
  };

  renderEditDrawer(): React.ReactNode {
    const { editingForm, saveError } = this.state;
    const { user } = this.props;

    if (!editingForm) {
      return null;
    }

    const studentsCount = propz.get(editingForm, ['studentsCount'], undefined);
    const status = propz.get(editingForm, ['status'], 'ACTIVE');
    const createdAt = propz.get(editingForm, ['createdAt'], '');
    const createdText = createdAt
      ? new Date(createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
      : 'Not available';

    return (
      <>
        <div className="schoolStructure-drawerScrim" onClick={this.onCancelButtonClick} />
        <aside className="schoolStructure-drawer schoolStructure-drawer--form" role="dialog" aria-modal="true">
          <div className="schoolStructure-drawer__head schoolStructure-drawer__head--rich">
            <span className="schoolStructure-drawer__leadIcon" aria-hidden="true">
              {this.renderFormIcon()}
            </span>
            <div>
              <div className="schoolStructure-drawer__eyebrow">School structure</div>
              <h2>{editingForm.name}</h2>
              <p>Update the registration form name and year group used across student records.</p>
            </div>
            <button
              type="button"
              className="schoolStructure-drawer__close"
              onClick={this.onCancelButtonClick}
              aria-label="Close"
            >
              ×
            </button>
          </div>
          <div className="schoolStructure-drawer__body">
            <div className="schoolStructure-detailStats">
              <div className="schoolStructure-detailStat">
                <span>Students</span>
                <strong>{typeof studentsCount === 'number' ? studentsCount.toLocaleString('en-GB') : '-'}</strong>
              </div>
              <div className="schoolStructure-detailStat">
                <span>Year group</span>
                <strong>{this.getFormAgeLabel(editingForm) || '-'}</strong>
              </div>
              <div className="schoolStructure-detailStat">
                <span>Status</span>
                <strong>{status}</strong>
              </div>
              <div className="schoolStructure-detailStat">
                <span>Created</span>
                <strong>{createdText}</strong>
              </div>
            </div>
            <div className="schoolStructure-formPanel">
              <div className="schoolStructure-formPanel__header">
                <div className="schoolStructure-formPanel__title">Registration form details</div>
                <button
                  type="button"
                  className="schoolStructure-btn schoolStructure-btn--danger"
                  onClick={this.onDeleteEditingFormClick}
                >
                  Delete
                </button>
              </div>
              {saveError && <div className="alert alert-danger mb-3">{saveError}</div>}
              <SchoolFormForm
                key={editingForm.id}
                isOpen={true}
                onCloseClick={this.onCancelButtonClick}
                onFormCreated={this.onSaveButtonClick}
                form={editingForm}
                user={user}
              />
            </div>
          </div>
        </aside>
      </>
    );
  }
  getFormAgeLabel(form: SchoolForm): string {
    return propz.get(form, ['ageGroup'], '');
  }

  onSearchChange = (event): void => {
    const filters = { ...this.state.filters, name: event.target.value };
    this.setState({ filters });
  };

  onSearchKeyDown = (event): void => {
    if (event.key === 'Enter') {
      this.onApplyFilterClick();
    }
  };

  getYearGroupOptions(): string[] {
    const { user } = this.props;
    const ageGroupsNaming = propz.get(user, ['activeSchool', 'ageGroupsNaming']);
    return propz.get(AGE_GROUPS_SORTED, [ageGroupsNaming], []);
  }

  getYearGroupFilterOptions(): PeopleFilterChipOption[] {
    const ageGroupsNaming = propz.get(this.props.user, ['activeSchool', 'ageGroupsNaming']);
    const ageGroups = propz.get(AGE_GROUPS, [ageGroupsNaming], []);
    const stageForAge = (age: number): Pick<PeopleFilterChipOption, 'group' | 'groupHint' | 'order'> => {
      if (age === 0) return { group: 'EYFS', groupHint: 'Reception', order: 0 };
      if (age <= 2) return { group: 'KS1', groupHint: 'Y1–Y2', order: 1 };
      if (age <= 6) return { group: 'KS2', groupHint: 'Y3–Y6', order: 2 };
      if (age <= 9) return { group: 'KS3', groupHint: 'Y7–Y9', order: 3 };
      if (age <= 11) return { group: 'KS4', groupHint: 'Y10–Y11', order: 4 };
      if (age <= 13) return { group: 'KS5', groupHint: 'Y12–Y13', order: 5 };
      return { group: 'Other', groupHint: '', order: 6 };
    };

    return this.getYearGroupOptions().map(ageGroup => {
      const age = ageGroups.indexOf(ageGroup);
      return {
        value: ageGroup,
        label: ageGroup,
        ...(ageGroupsNaming === 'ENGLISH' && age !== -1 ? stageForAge(age) : { order: age === -1 ? 0 : age })
      };
    });
  }

  onYearGroupFilterChange = (event): void => {
    const value = event;
    const filters = { ...this.state.filters };
    const selected = Array.isArray(filters.ageGroup) ? filters.ageGroup : [];
    const isSelected = selected.indexOf(value) !== -1;
    const ageGroup = isSelected ? selected.filter(item => item !== value) : [...selected, value];

    if (ageGroup.length > 0) {
      filters.ageGroup = ageGroup;
    } else {
      delete filters.ageGroup;
    }

    this.setState({ filters });
  };

  onRemoveFilterChip = (field: string): void => {
    const filters = { ...this.state.filters };
    delete filters[field];
    this.setState({ filters }, this.onApplyFilterClick);
  };

  onWithoutStudentsFilterChange = (value: string): void => {
    const filters = { ...this.state.filters };
    const selected = Array.isArray(filters.withoutStudents) ? filters.withoutStudents : [];
    const withoutStudents =
      selected.indexOf(value) !== -1 ? selected.filter(item => item !== value) : [...selected, value];

    if (withoutStudents.length > 0) {
      filters.withoutStudents = withoutStudents;
    } else {
      delete filters.withoutStudents;
    }

    this.setState({ filters });
  };

  renderFormIcon(): React.ReactNode {
    return <span className="schoolStructure-formIcon" aria-hidden="true" />;
  }

  renderToolbar(): React.ReactNode {
    const { filters, totalWithFilters, isShowFilter } = this.state;
    const searchValue = propz.get(filters, ['name'], '');
    const selectedYearGroups = propz.get(filters, ['ageGroup'], []);
    const selectedWithoutStudents = propz.get(filters, ['withoutStudents'], []);
    const filterCount = selectedYearGroups.length + selectedWithoutStudents.length;
    const hasActiveFilters = isFilterExist2(filters);

    return (
      <div className="schoolStructure-toolbar schoolStructure-toolbar--inlineFilters">
        <div className="schoolStructure-toolbar__titleControls">
          <div className="schoolStructure-toolbar__heading">
            <h2>Registration forms</h2>
            <span>{totalWithFilters}</span>
          </div>
          <label className="schoolStructure-search schoolStructure-search--compact">
            <input
              type="text"
              aria-label="Search registration forms"
              value={searchValue}
              placeholder="Search registration forms..."
              onChange={this.onSearchChange}
              onKeyDown={this.onSearchKeyDown}
            />
          </label>
          <button
            type="button"
            className={`schoolStructure-btn schoolStructure-btn--secondary schoolStructure-filterBtn${
              isShowFilter ? ' schoolStructure-btn--active' : ''
            }`}
            onClick={this.onTableFilterClick}
          >
            <span className="schoolStructure-buttonIcon schoolStructure-buttonIcon--filter" aria-hidden="true" />
            Filters
            {filterCount > 0 ? (
              <span className="schoolStructure-filterCount">{filterCount}</span>
            ) : null}
          </button>
          {hasActiveFilters ? (
            <button type="button" className="schoolStructure-clearFilters" onClick={this.onClearFilterClick}>
              Clear filters
            </button>
          ) : null}
        </div>
        <div className="schoolStructure-toolbar__controls">
          <button
            type="button"
            className="schoolStructure-btn schoolStructure-btn--primary"
            onClick={this.onCreateFormClick}
          >
            <span aria-hidden="true">+</span>
            Create registration form
          </button>
        </div>
      </div>
    );
  }

  renderFilters(): React.ReactNode {
    const { filters, isShowFilter } = this.state;

    if (!isShowFilter) {
      return null;
    }

    const selected = propz.get(filters, ['ageGroup'], []);
    const selectedWithoutStudents = propz.get(filters, ['withoutStudents'], []);
    const options = this.getYearGroupFilterOptions();

    return (
      <>
        <div className="schoolStructure-drawerScrim" onClick={this.onTableFilterClick} />
        <aside
          className="schoolStructure-drawer schoolStructure-drawer--filters"
          aria-label="Registration form filters"
        >
          <div className="schoolStructure-drawer__head">
            <div>
              <h2>Filters</h2>
            </div>
            <button
              type="button"
              className="schoolStructure-drawer__close"
              aria-label="Close filters"
              onClick={this.onTableFilterClick}
            >
              ×
            </button>
          </div>
          <div className="schoolStructure-drawer__body schoolStructure-filterSections">
            <PeopleFilterChipSelect
              label="Age group"
              options={options}
              selected={selected}
              onToggle={this.onYearGroupFilterChange}
            />
            <PeopleFilterChipSelect
              label="Student assignments"
              options={[{ value: 'true', label: 'No students attached' }]}
              selected={selectedWithoutStudents}
              onToggle={this.onWithoutStudentsFilterChange}
            />
          </div>
          <div className="schoolStructure-drawer__footer schoolStructure-filterFooter">
            <button
              type="button"
              className="schoolStructure-btn schoolStructure-btn--secondary is-clear"
              onClick={this.onClearFilterClick}
            >
              Clear all
            </button>
            <div>
              <button
                type="button"
                className="schoolStructure-btn schoolStructure-btn--secondary"
                onClick={this.onTableFilterClick}
              >
                Cancel
              </button>
              <button
                type="button"
                className="schoolStructure-btn schoolStructure-btn--primary is-apply"
                onClick={this.onApplyFilterClick}
              >
                Apply
              </button>
            </div>
          </div>
        </aside>
      </>
    );
  }

  renderActiveFilters(): React.ReactNode {
    const filters = { ...this.state.filters };
    delete filters.name;

    return (
      <PeopleFilterChips
        filters={filters}
        columns={[
          { field: 'ageGroup', text: 'Age group' },
          { field: 'withoutStudents', text: 'Student assignments' }
        ]}
        valueLabels={{ withoutStudents: { true: 'No students attached' } }}
        onRemove={this.onRemoveFilterChip}
        onClear={this.onClearFilterClick}
      />
    );
  }

  renderSelectionBar(): React.ReactNode {
    const { selectedItems } = this.state;
    const selectedCount = selectedItems.length;

    if (selectedCount === 0) {
      return null;
    }

    return (
      <div className="schoolStructure-selection">
        <span className="schoolStructure-selection__summary">
          {selectedCount} {selectedCount === 1 ? 'registration form' : 'registration forms'} selected
        </span>
        <div className="schoolStructure-selection__actions">
          <button
            type="button"
            className="schoolStructure-btn schoolStructure-btn--danger"
            onClick={this.onRemoveFormClick}
          >
            Delete
          </button>
        </div>
        <div className="schoolStructure-toolbar__spacer" />
        <button type="button" className="schoolStructure-selection__clear" onClick={this.onUnselectAllClick}>
          Clear selection
        </button>
      </div>
    );
  }

  renderBulkSelect(): React.ReactNode {
    const { items, selectedItems, isSelectionMenuOpen } = this.state;
    const selectedIds = new Set(selectedItems.map(item => item.id));
    const allPageSelected = items.length > 0 && items.every(item => selectedIds.has(item.id));

    return (
      <div className="people-bulkSelect schoolStructure-bulkSelect">
        <button
          type="button"
          className={`people-bulkSelect__trigger ${allPageSelected ? 'people-bulkSelect__trigger--checked' : ''}`}
          aria-label="Bulk select registration forms"
          aria-expanded={isSelectionMenuOpen}
          onClick={event => {
            event.stopPropagation();
            this.setState({ isSelectionMenuOpen: !isSelectionMenuOpen });
          }}
        >
          <span className="people-bulkSelect__box" />
        </button>
        {isSelectionMenuOpen && (
          <div className="people-bulkSelect__menu">
            <button type="button" onClick={this.onSelectAllOnPageClick}>
              Select this page
            </button>
            <button type="button" onClick={this.onSelectAllClick}>
              Select all
            </button>
            <button type="button" disabled={selectedItems.length === 0} onClick={this.onUnselectAllClick}>
              Clear selection
            </button>
          </div>
        )}
      </div>
    );
  }

  renderFormsTable(): React.ReactNode {
    const {
      items,
      selectedItems,
      sortColumnsName,
      sortDirection,
      currentPage,
      totalWithFilters,
      editingForm
    } = this.state;
    const selectedIds = new Set(selectedItems.map(item => item.id));
    const pageCount = Math.max(1, Math.ceil(totalWithFilters / LIMIT));
    const pageNumbers = Array.from({ length: pageCount }, (_, index) => index + 1).filter(page => {
      return page === 1 || page === pageCount || Math.abs(page - currentPage) <= 2;
    });

    return (
      <>
        <div className="schoolStructure-tableCard">
          <div className="schoolStructure-tableScroll">
            <table className="schoolStructure-table">
              <thead>
                <tr>
                  <th className="schoolStructure-table__check">{this.renderBulkSelect()}</th>
                  <th className="schoolStructure-table__sortable" onClick={() => this.onTableSortClick('name')}>
                    <span>Form</span>
                    <i className={`people-sort ${sortColumnsName === 'name' ? `people-sort--${sortDirection}` : ''}`} />
                  </th>
                  <th>Year group</th>
                  <th>Students</th>
                </tr>
              </thead>
              <tbody>
                {items.length === 0 ? (
                  <tr>
                    <td className="schoolStructure-empty" colSpan={4}>
                      No registration forms match your search.
                    </td>
                  </tr>
                ) : (
                  items.map((form, index) => {
                    const isSelected = selectedIds.has(form.id);
                    const isPreviewed = Boolean(editingForm && editingForm.id === form.id);
                    const studentsCount = propz.get(form, ['studentsCount'], undefined);
                    const isLinked = propz.get(form, ['isContainStudents'], undefined);
                    const hasStudentsCount = typeof studentsCount === 'number';
                    const studentsText = hasStudentsCount
                      ? `${studentsCount} student${studentsCount === 1 ? '' : 's'}`
                      : typeof isLinked === 'boolean'
                      ? isLinked
                        ? 'Linked students'
                        : 'No linked students'
                      : 'Unavailable';

                    return (
                      <tr
                        key={form.id}
                        data-selected={isSelected}
                        data-preview={isPreviewed}
                        onClick={() => this.onItemClick(index)}
                      >
                        <td className="schoolStructure-table__check" onClick={event => event.stopPropagation()}>
                          <input type="checkbox" checked={isSelected} onChange={() => this.onItemSelect(index)} />
                        </td>
                        <td>
                          <span className="schoolStructure-rowTitle">
                            {this.renderFormIcon()}
                            <span className="schoolStructure-rowTitle__text">
                              <strong>{form.name}</strong>
                              <small>{this.getFormAgeLabel(form) || ''}</small>
                            </span>
                          </span>
                        </td>
                        <td>
                          <span className="schoolStructure-badge schoolStructure-badge--age">
                            {this.getFormAgeLabel(form)}
                          </span>
                        </td>
                        <td>
                          <span
                            className={`schoolStructure-countPill ${
                              hasStudentsCount && studentsCount > 0 ? '' : 'schoolStructure-countPill--muted'
                            }`}
                          >
                            {studentsText}
                          </span>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="schoolStructure-pagination">
          <span className="schoolStructure-pagination__summary">
            Page {currentPage} of {pageCount}
          </span>
          <button
            type="button"
            className="schoolStructure-btn schoolStructure-btn--secondary"
            disabled={currentPage <= 1}
            onClick={() => this.setCurrentPageParams(currentPage - 1)}
          >
            Previous
          </button>
          {pageNumbers.map((page, index) => {
            const prevPage = pageNumbers[index - 1];
            return (
              <React.Fragment key={page}>
                {prevPage && page - prevPage > 1 ? (
                  <span className="schoolStructure-pagination__ellipsis">...</span>
                ) : null}
                <button
                  type="button"
                  className={`schoolStructure-pageBtn ${page === currentPage ? 'schoolStructure-pageBtn--active' : ''}`}
                  onClick={() => this.setCurrentPageParams(page)}
                >
                  {page}
                </button>
              </React.Fragment>
            );
          })}
          <button
            type="button"
            className="schoolStructure-btn schoolStructure-btn--secondary"
            disabled={currentPage >= pageCount}
            onClick={() => this.setCurrentPageParams(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </>
    );
  }
  render() {
    const { isLoading, isCreateOrEditFormModalOpen, isDeleteFormConfirmationModalOpen, editingForm } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes =
      isCreateOrEditFormModalOpen || isDeleteFormConfirmationModalOpen || editingForm ? 'mt-3 modal-open' : 'mt-3';

    return (
      <div className={classes}>
        {this.renderDeleteFormConfirmationModal()}
        {this.renderDeleteFormProhibitionModal()}
        {this.renderForm()}
        {this.renderEditDrawer()}
        {this.renderFilters()}
        {this.renderToolbar()}
        {this.renderActiveFilters()}
        {this.renderSelectionBar()}
        {this.renderFormsTable()}
      </div>
    );
  }
}
